import React, { useEffect } from 'react'
import { TextFieldSeeker } from "@ui-seeker/core"
import useAdminNewOfficeInfo from "Pages/Admin/Users/@hooks/useNewOfficeInfo"
import { useValidatorSeeker } from "@app"
import { object, string } from "yup"
import { isValidNewOffice, newOfficePayload } from "Pages/Admin/Users/@signals"
import { useComputed } from "@preact/signals-react"


export default function OfficeCodeField() {

	const isAirport = useComputed(() => newOfficePayload.value.officeType === "is_airport")
	const { iataCode, setIataCodeInfo } = useAdminNewOfficeInfo("", "iataCode")
	const { errors, isValid } = useValidatorSeeker({ iataCode: iataCode }, object({
		...isAirport.value && {
			iataCode: string().required('Must provide an Office Code')
		}
	}))

	useEffect(() => {
		isValidNewOffice.value = { ...isValidNewOffice.value, iataCode: isValid }
	}, [isValid])

	useEffect(() => {
		if (!isAirport.value) {
			setIataCodeInfo("")
		}
	}, [isAirport.value])

	return <TextFieldSeeker
		value={iataCode}
		onChange={e => {
			if (e.target.value.length <= 3) {
				setIataCodeInfo(e.target.value.toUpperCase())
			}
		}}
		disabled={!isAirport.value}
		label="IATA Code"
		placeholder="IATA Code"
		error={errors.iataCode}
	/>
}